import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const apiSlice = createApi({
  reducerPath: 'api',
  baseQuery: fetchBaseQuery({ 
    baseUrl: process.env.REACT_APP_BACKEND_URL,
    credentials: 'include',
    prepareHeaders: (headers, { getState }) => {
      let token= getState().auth?.token;
      if(token){
        headers.set('authorization', `Bearer ${token}`);
      }
      return headers
    },
  }),
  // baseQuery:fetchBaseQuery({ baseUrl: ''}),
  endpoints: (builder) => ({}),
  tagTypes: ['Users'],
});


